import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-add-contact',
    templateUrl: './add-contact.component.html',
    styleUrls: ['./add-contact.component.scss'],
    standalone: false
})
export class AddContactComponent {

  constructor (
    @Inject(MAT_DIALOG_DATA) public data: { email: string },
    public dialogRef: MatDialogRef<AddContactComponent>) { }

  handleSubmit(name, jobDescription) {
    if (name && jobDescription) {
      this.dialogRef.close({ name, jobDescription });
    } else {
      return false;
    }
  }

}
